import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: [],
  defaultId: 'default',
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: '12',
  opened: true,
  navType: 'light',
  adminOption: '',
  globalAlert: false,
  language: '',
  choicedPlan: '',
  snackbar: {
    open: false,
    type: 'info', // success | error | warning 
    message: ''
  },
};

const customizationSlice = createSlice({
  name: 'customization',
  initialState,
  reducers: {
    menuOpen: (state, action) => {
      state.isOpen = [action.payload];
    },
    setGlobalAlert: (state, action) => {
      state.globalAlert = action.payload;
    },
    setMenu: (state, action) => {
      state.opened = action.payload;
    },
    setFontFamily: (state, action) => {
      state.fontFamily = action.payload;
    },
    setBorderRadius: (state, action) => {
      state.borderRadius = action.payload;
    },
    setWidthSidebar: (state, action) => {
      state.widthSidebar = action.payload;
    },
    setWidthComments: (state, action) => {
      state.widthComments = action.payload;
    },
    setNavType: (state, action) => {
      state.navType = action.payload;
    },
    setAdminOption: (state, action) => {
      state.adminOption = action.payload;
    },
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
    setPlanToAdmin: (state, action) => {
      state.choicedPlan = action.payload;
    },
    showSnackbar: (state, action) => {
      const { type = 'info', message = '' } = action.payload || {};
      state.snackbar.open = true;
      state.snackbar.type = type;
      state.snackbar.message = message;
    },
    hideSnackbar: (state) => {
      state.snackbar.open = false;
      state.snackbar.message = '';
    },
  },
});

export const {
  menuOpen,
  setMenu,
  setFontFamily,
  setBorderRadius,
  setGlobalAlert,
  setWidthSidebar,
  setWidthComments,
  setNavType,
  setAdminOption,
  setLanguage,
  setPlanToAdmin,
  showSnackbar,
  hideSnackbar,
} = customizationSlice.actions;
export default customizationSlice.reducer;
